import axios from 'axios'

class MosqueRequestsService {
  getMosqueRequests = (page, size, search = null, status = null) =>
    axios({
      url: 'mosque-request/admin',
      method: 'GET',
      params: {
        page,
        limit: size,
        search: search || null,
        status: status || null,
      },
    })

  getMosqueRequestById = (id) =>
    axios({
      url: `mosque-request/admin/${id}`,
      method: 'GET',
    })

  updateMosqueRequestStatus = (id, status) =>
    axios({
      url: `mosque-request/admin/${id}/status`,
      method: 'PATCH',
      data: { status },
    })
}

export default new MosqueRequestsService()

